<template>
  <div class="main-content">
    <div class="wrap-content container" id="container">
      <!-- start: PAGE TITLE -->
      <section id="page-title" style="background-color: #d1d1d1;">
        <div class="row">
          <div class="col-sm-10">
            <h1 class="mainTitle">All Lab/Scan Appointments</h1>
          </div>
          <div class="col-sm-2">
            <!-- <router-link style="margin-right: 10px" class="btn btn-primary"
              :to="{ name: 'create-appointmentLab' }">create</router-link> -->
            <!-- <router-link class="btn btn-success" :to="{ name: 'deleted-appointmentLabs' }">Deleted
              Appointments</router-link> -->
          </div>

        </div>
      </section>
      <!-- end: PAGE TITLE -->
      <!-- start: DYNAMIC TABLE -->
      <div class="container-fluid container-fullw bg-white">
        <div class="row">
          <div class="col-md-12">

            <div v-if="appointmentLabs.length > 0">
              <MyTable :columns="columns" :actions="true">
                <tr v-for="(lab, index) in appointmentLabs" :key="index">
                  <th scope="row">{{ lab.id }}</th>
                  <td>{{ lab.appointment_data ? lab.appointment_data.lab_name : '' }}</td>
                  <td>{{ lab.appointment_data ? lab.appointment_data.service_name : '' }}</td>
                  <td>{{ lab.appointment_type }}</td>

                  <td>{{ lab.appointment_day ? lab.appointment_day.name : '' }}</td>
                  <td>{{ lab.appointment_hour ? lab.appointment_hour.from + ' - ' +
                    lab.appointment_hour.to : '' }}</td>


                  <!-- <td>{{ lab.service_id ? lab.service_id.name : '' }}</td> -->
                  <td>
                    <button class="me-2 btn btn-danger" v-if="hasPermission('lab/scan-appointments delete')"
                      @click="deleteLab(lab.id)">
                      Delete
                    </button>
                    <router-link v-if="hasPermission('lab/scan-appointments update')" class="btn btn-primary spacing"
                      :to="{ name: 'edit-appointmentLab', params: { id: lab.id } }">
                      <!-- :to="{ name: 'edit-appointmentLab', params: { id: lab.appointment_data ? lab.appointment_data.lab_id : lab.id } }"> -->
                      Edit
                    </router-link>
                    <!-- <router-link class="btn btn-primary spacing"
                      :to="{ name: 'edit-appointmentLab', params: { id: lab.id } }">
                      Edit
                    </router-link> -->
                  </td>

                </tr>
              </MyTable>
            </div>
            <div v-else class="alert alert-info">
              No Appointments found.
            </div>
          </div>
        </div>
      </div>
      <!-- end: DYNAMIC TABLE -->
    </div>
  </div>
</template>

<script>
import axios from "../../Axios";
import { store } from "../../Store";
import $ from 'jquery'; // Import jQuery
import MyTable from "../MyTable//MyTable.vue"; // Import your MyTable component

export default {
  name: "AllAppointmentLabs",
  components: {
    MyTable,
    // Paginate,
  },
  data() {
    return {
      dataTable: [], // Store DataTable instance
      appointmentLabs: [],
      meta: {},
      searchTerm: "",
      columns: [
        { label: '#', key: 'id' },
        { label: 'Name', key: 'appointment_data.lab_name' },
        { label: 'Main Service', key: 'appointment_data.service_name' },
        { label: 'Appointment Type', key: 'appointment_type' },
        { label: 'Day', key: 'appointment_day' },
        { label: 'Hour', key: 'appointment_hour' },
      ],
    };
  },

  async created() {
    this.fetchLabs();
  },

  computed: {
    hasPermission() {
      return (permission) => store.hasPermission(permission);
    },
    filteredLabs() {
      if (!this.searchTerm) {
        return this.appointmentLabs;
      }
      const term = this.searchTerm.toLowerCase();
      return this.appointmentLabs.filter(
        (lab) =>
          lab.name.toLowerCase().includes(term)
      );
    },
  },

  methods: {
    // fetch labs
    async fetchLabs() {
      try {
        const response = await axios.get(
          `/admin/admin/appointment-lab/all`
        );
        this.appointmentLabs = response.data.data;
        this.meta = response.data.meta;
        this.$nextTick(() => {
          this.initializeDataTable(); // Initialize DataTable after fetching users
        });
      } catch (error) {
        console.error("Error fetching appointment-Labs:", error);
      }
    },
    initializeDataTable() {
      this.$nextTick(() => {
        $('.sample_1').DataTable(); // Initialize DataTable
      });
    },
    // initializeDataTable() {
    //   this.$nextTick(() => {
    //     if (this.dataTable) {
    //       this.dataTable.destroy(); // Destroy existing DataTable instance if it exists
    //     }
    //     this.dataTable = $('.sample_1').DataTable(); // Initialize DataTable
    //   });
    // },
    deleteLab(id) {
      axios
        .delete(`/admin/admin/appointment-lab/delete?id=${id}`)
        .then((response) => {
          console.log(response.data);
          this.fetchLabs();
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },

};
</script>
<style scoped>
.table {
  margin-top: 10px;
}

.spacing {
  margin-left: 10px !important;
}
</style>